/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Button, Switch } from '@carbon/react';
import { OpenPanelRight } from '@carbon/icons-react';

import * as Styled from './HeaderControls.styled';
/**
 * @param {{
 *   isPdfViewerVisible: boolean,
 *   onTogglePdfViewer: (visible: boolean) => void,
 *   selectedView: 'forms' | 'tables',
 *   handleViewChange: (event: { name: 'forms' | 'tables' }) => void
 * }} props
 * @returns {JSX.Element}
 */
export function HeaderControls({ isPdfViewerVisible, onTogglePdfViewer, selectedView, handleViewChange }) {
  return (
    <Styled.HeaderControls>
      <Styled.StyledContentSwitcher
        onChange={handleViewChange}
        selectedIndex={selectedView === 'forms' ? 0 : 1}
        size="md"
      >
        <Switch name="forms" text="Forms" />
        <Switch name="tables" text="Tables" />
      </Styled.StyledContentSwitcher>
      <Button
        kind="ghost"
        hasIconOnly
        renderIcon={OpenPanelRight}
        iconDescription={isPdfViewerVisible ? 'Hide document viewer' : 'Show document viewer'}
        onClick={() => onTogglePdfViewer(!isPdfViewerVisible)}
        size="sm"
        aria-label={isPdfViewerVisible ? 'Hide document viewer' : 'Show document viewer'}
      />
    </Styled.HeaderControls>
  );
}
